export enum CommunicationChannel {
  EMAIL = "EMAIL",
  SMS = "SMS",
  JULO_CHAT = "JULO_CHAT",
}
